import { Component, HostListener, Input, ViewChild } from "@angular/core";
import { hide } from "@popperjs/core";
import { isNullOrUndefined } from "../validation";
import { DashboardNewService } from "../services/dashboard-new.service";
import { EncrdecrService } from "../Auth/encrdecr.service";
import { CustomLoaderService } from "../services/custom-loader.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DealEntryTRPMSService } from "../services/deal-entry-tr-pms.service";
import { DatePipe } from "@angular/common";
import { ReportService } from "../services/report.service";
import { ClientService } from "../services/client.service";
import { TokenExpireService } from "../services/token-expire.service";
import { LumpsumBseComponent } from "../transaction-shared/lumpsum-bse/lumpsum-bse.component";

declare var $: any;
@Component({
  selector: "app-mf-central",
  templateUrl: "./mf-central.component.html",
  styleUrls: ["./mf-central.component.scss"],
})
export class MfCentralComponent {
  @ViewChild("ngOtpInput", { static: false }) ngOtpInput: any;
  OTPForm: FormGroup;

  @Input() User_Id: any;
  UserType: any;
  EmpID: any;
  SubbrokerID: any;

  GetMobileForm: FormGroup;
  UpdateMobileForm: FormGroup;

  IsMobile: boolean = false;
  IsAll: boolean = true;
  IsJM: boolean = false;
  IsExternal: boolean = false;

  IsUpdateHolding: boolean = false;
  GetMobileFormSubmit: boolean = false;
  UpdateMobFormSubmit: boolean = false;
  IsVerify: boolean = false; //Otp Verify Failed Message

  OtpTimer: number = 90; //OTP Enter Time
  OtpTimeRemening: any = "01:30";
  OTP_Timer_Function: any;

  alertheader: string = "Alert!";
  ClientName: string = "";
  ClientPan: string = "";
  clientemail: string = "";
  MobileNo: string = "";
  MaskingMobileNo: string = "";
  G_ClientBasicInfoId: string = "";
  isTrxnDetailsShowID: string = "";

  SelectedMobileNumbers: any[] = [];
  OtpSendResponse: any[] = [];

  SelectedUniPFData: any[] = [];
  AllFundSnapShotDetails: any[] = [];
  JMSnapShotDetails: any[] = [];
  HeldAwaySnapShotDetails: any[] = [];

  SelectedAllUniversalPortFolioHoldingData: any[] = [];
  AllFundAllSchemeListDetails: any[] = [];
  JMAllSchemeListDetails: any[] = [];
  HeldAwayAllSchemeListDetails: any[] = [];

  TrxnDetailsDataList: any[] = [];

  ExportToPDFData: any[] = [];
  ExportToExcelData: any[] = [];

  ExportToPDFALLFundData: any[] = [];
  ExportToPDFJMData: any[] = [];
  ExportToPDFHeldAwayData: any[] = [];
  ExportToPDFALLFundData_EMP: any[] = [];
  ExportToPDFJMData_EMP: any[] = [];
  ExportToPDFHeldAwayData_EMP: any[] = [];

  ExportToExcelALLFundData: any[] = [];
  ExportToExcelJMData: any[] = [];
  ExportToExcelHeldAwayData: any[] = [];
  ExportToExcelALLFundData_EMP: any[] = [];
  ExportToExcelJMData_EMP: any[] = [];
  ExportToExcelHeldAwayData_EMP: any[] = [];

  AllFundPurchaseValue: any = "0.00";
  AllFundCurrentValue: any = "0.00";
  AllFundGainLoss: any = "0.00";
  AllFundAbcReturnValue: any = "0.00";
  AllFundXIRRValue: any = "0.00";
  AllFundAsOnDateBinding: Date;

  JMPurchaseValue: any = "0.00";
  JMCurrentValue: any = "0.00";
  JMGainLoss: any = "0.00";
  JMAbcReturnValue: any = "0.00";
  JMXIRRValue: any = "0.00";
  JMAsOnDateBinding: Date;

  HeldAwayPurchaseValue: any = "0.00";
  HeldAwayCurrentValue: any = "0.00";
  HeldAwayAbcReturnValue: any = "0.00";
  HeldAwayGainLoss: any = "0.00";
  HeldAwayXIRRValue: any = "0.00";
  HeldAwayAsOnDateBinding: Date;

  TrxnDetFolioNumber: string = "";

  isShowMoreLess: boolean;
  // isCollapsed: boolean[] = [];
  currentIndex: number | null = null;

  // EmployeeFilter Variable

  DDLFilterType: string = "T";

  SubBrokerName: any = "";

  AddFamilyMemberForm: FormGroup;
  AddFamilyMemberFormSubmitted: boolean = false;
  isFamilyDisabled: boolean = true;
  RdbReportTypeEmp: boolean = true;

  G_ROLEID: number;
  G_LoginId: string = "";
  flag: string = "";
  DashboardUserId: string = "";
  ClientBasicInfoId_Emp: string = "";

  EmpClientList: any;
  ClientList: any;
  ZoneList: any;
  RegionList: any;
  BranchList: any;
  SelectedBranch: any;
  EmpSelectedClientList: any;
  SelectedEmployee: any;
  SubBrokerList: any;
  SelectedSubBroker: any;
  SelectedClientList: any;
  FamilyList: any;
  SelectedFamilyList: any;
  EmployeeList: any;
  SelectedZone: any;

  InvalidPan: boolean = false;
  ///single client get mfcentral transaction details
  isEmpSub: string = "";
  isMultiSelect: boolean = false;
  showBtnReport: boolean = true;

  EmployeeSetting = {};
  SubBrokerSetting = {};
  ClientSetting = {};
  EmpClientSetting = {};
  BranchSetting = {};
  RegionSetting = {};
  ZoneSetting = {};
  FamilySetting = {};

  SelectedClientEmpAll: any = [];
  EmployeeResult: any = [];
  EmpClientResult: any = [];
  ClientResult: any = [];
  SubBRokerResult: any = [];
  RegionResult: any = [];
  ZoneResult: any = [];
  BranchResult: any = [];
  FamilyResult: any = [];
  InvestorsList: any[] = [];
  TempInvestorsList: any[] = [];
  TempClientData: any[] = [];
  FinalClientData: any[] = [];
  TempFamilyData: any[] = [];

  SelectedClientEmp: any = [];
  SelectedRegion: any;

  // Redirect page binding variable
  selectedBSESchemeCode: string = "";
  selectedBSEAMCCode: string = "";
  selectedFCTSchemeCode: string = "";
  selectedFolio: string = "";
  AMCCodeLogo: string = "";
  SchemeType: string = "";
  CategoryCode: string = "";
  SchemeName: string = "";
  RedirectPageName: string = "";
  DifferentiateScheme: any;

  constructor(
    private Loader: CustomLoaderService,
    private EncrdecrService: EncrdecrService,
    private DashboardNewService: DashboardNewService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private reportservice: ReportService,
    private clientService: ClientService,
    private Logout: TokenExpireService
  ) {
    //OTP Info Form
    this.OTPForm = this.formBuilder.group({
      OTP: ["", [Validators.required, Validators.minLength(6)]],
    });

    this.GetMobileForm = this.formBuilder.group({
      MobileNo: ["", [Validators.required]],
    });

    //Edit Mobile Number
    this.UpdateMobileForm = this.formBuilder.group({
      UpdateMob: [
        "",
        [
          Validators.required,
          Validators.pattern("^((\\+91-?)|0)?[6-9]{1}[0-9]{9}$"),
        ],
      ],
    });

    // this.isCollapsed = new Array(this.AllFundAllSchemeListDetails.length).fill(false);
    this.AddFamilyMemberForm = formBuilder.group({
      //ClientBasicInfoId:[0],
      FamilyName: ["", [Validators.required]],
      FamilyInvestorName: ["", [Validators.required]],
      FamilyInvRelation: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    debugger;
    this.isEmpSub = "";
    this.SetViewPort(window.innerWidth);
    if (
      !isNullOrUndefined(sessionStorage.getItem("L2D3506kIHSk3E0")) &&
      sessionStorage.getItem("L2D3506kIHSk3E0") != ""
    ) {
      this.UserType = this.EncrdecrService.getDecr(
        sessionStorage.getItem("L2D3506kIHSk3E0")
      );
    } else {
      console.log("usertype not fund");
    }

    if (this.UserType == 1) {
      this.G_LoginId = this.EncrdecrService.getDecr(
        sessionStorage.getItem("F44sGAGh2xwkpUL")
      ).toString();
      if (
        sessionStorage.getItem("5gE4QWzFXWKewRC") != null &&
        sessionStorage.getItem("5gE4QWzFXWKewRC") != undefined
      ) {
        this.G_ROLEID = parseInt(
          this.EncrdecrService.getDecr(
            sessionStorage.getItem("5gE4QWzFXWKewRC")
          )
        ); //Session_ROLEID
        if (this.UserType == 1) {
          if (
            sessionStorage.getItem("yugdchbcdhjs87") != null &&
            sessionStorage.getItem("yugdchbcdhjs87") != undefined
          ) {
            this.EmpID = this.EncrdecrService.getDecr(
              sessionStorage.getItem("F44sGAGh2xwkpUL")
            );
          }
          this.BindFilters();
          $("#ddlZone .dropdown-list").append(
            `<div class='btnmultiselect'><button id='btnZone' >Okay</button></div>`
          );
          $("#ddlRegion .dropdown-list").append(
            `<div class='btnmultiselect'><button id='btnRegion' >Okay</button></div>`
          );
          $("#ddlBranch .dropdown-list").append(
            `<div class='btnmultiselect'><button id='btnBranch' >Okay</button></div>`
          );
          $("#ddlEmployee .dropdown-list").append(
            `<div class='btnmultiselect'><button id='btnEmployee' >Okay</button></div>`
          );
          $("#ddlSubBroker .dropdown-list").append(
            `<div class='btnmultiselect'><button id='btnSubBroker' >Okay</button></div>`
          );
          $("#ddlFamily .dropdown-list").append(
            `<div class='btnmultiselect'><button id='btnFamily' >Okay</button></div>`
          );
          $("#ddlClients .dropdown-list").append(
            `<div class='btnmultiselect'><button id='btnClient' >Okay</button></div>`
          );
          $("#ddlEmpClient .dropdown-list").append(
            `<div class='btnmultiselect'><button id='btnEmpClient' >Okay</button></div>`
          );
        }
      }
    } else if (this.UserType == 2) {
      this.SubbrokerID = this.G_LoginId = this.EncrdecrService.getDecr(
        sessionStorage.getItem("F44sGAGh2xwkpUL")
      ).toString();

      this.BindFilters();
      $("#ddlZone .dropdown-list").append(
        `<div class='btnmultiselect'><button id='btnZone' >Okay</button></div>`
      );
      $("#ddlRegion .dropdown-list").append(
        `<div class='btnmultiselect'><button id='btnRegion' >Okay</button></div>`
      );
      $("#ddlBranch .dropdown-list").append(
        `<div class='btnmultiselect'><button id='btnBranch' >Okay</button></div>`
      );
      $("#ddlEmployee .dropdown-list").append(
        `<div class='btnmultiselect'><button id='btnEmployee' >Okay</button></div>`
      );
      $("#ddlSubBroker .dropdown-list").append(
        `<div class='btnmultiselect'><button id='btnSubBroker' >Okay</button></div>`
      );
      $("#ddlFamily .dropdown-list").append(
        `<div class='btnmultiselect'><button id='btnFamily' >Okay</button></div>`
      );
      $("#ddlClients .dropdown-list").append(
        `<div class='btnmultiselect'><button id='btnClient' >Okay</button></div>`
      );
      $("#ddlEmpClient .dropdown-list").append(
        `<div class='btnmultiselect'><button id='btnEmpClient' >Okay</button></div>`
      );
    } else {
      if (this.UserType == 3) {
        if (
          !isNullOrUndefined(sessionStorage.getItem("m5JkoXISmYRAIuY")) &&
          sessionStorage.getItem("m5JkoXISmYRAIuY") != ""
        ) {
          this.ClientPan = this.EncrdecrService.getDecr(
            sessionStorage.getItem("m5JkoXISmYRAIuY")
          );
        } else {
          console.log(
            "MFCentral client pan : not found" +
              this.EncrdecrService.getDecr(
                sessionStorage.getItem("m5JkoXISmYRAIuY")
              )
          );
        }
        if (
          !isNullOrUndefined(sessionStorage.getItem("Xe003SRRyYEoOC2")) &&
          sessionStorage.getItem("Xe003SRRyYEoOC2") != ""
        ) {
          this.MobileNo = this.EncrdecrService.getDecr(
            sessionStorage.getItem("Xe003SRRyYEoOC2")
          );
        } else {
          console.log(
            "MFCentral client mobile number: not found" +
              this.EncrdecrService.getDecr(
                sessionStorage.getItem("Xe003SRRyYEoOC2")
              )
          );
        }
        if (
          !isNullOrUndefined(sessionStorage.getItem("V4WGROuLLBE6t98")) &&
          sessionStorage.getItem("V4WGROuLLBE6t98") != ""
        ) {
          this.ClientName = this.EncrdecrService.getDecr(
            sessionStorage.getItem("V4WGROuLLBE6t98")
          );
        } else {
          console.log(
            "MFCentral ClientName: not found" +
              this.EncrdecrService.getDecr(
                sessionStorage.getItem("V4WGROuLLBE6t98")
              )
          );
        }

        if (
          !isNullOrUndefined(sessionStorage.getItem("UZT6qHaDZSz66kx")) &&
          sessionStorage.getItem("UZT6qHaDZSz66kx") != ""
        ) {
          this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(
            sessionStorage.getItem("UZT6qHaDZSz66kx")
          );
        } else {
          console.log(
            "MFCentral clientbasicinfoid : not found" +
              this.EncrdecrService.getDecr(
                sessionStorage.getItem("UZT6qHaDZSz66kx")
              )
          );
        }

        //Session set on business-snapshot-client component for MF Central
        if (
          !isNullOrUndefined(sessionStorage.getItem("asdfMFCdsfk*jf#CeDKF=")) &&
          sessionStorage.getItem("asdfMFCdsfk*jf#CeDKF=") != ""
        ) {
          let IsHoldingOrNot = this.EncrdecrService.getDecr(
            sessionStorage.getItem("asdfMFCdsfk*jf#CeDKF=")
          );

          if (
            IsHoldingOrNot &&
            (IsHoldingOrNot.includes("HoldingDataNot") ||
              IsHoldingOrNot == "HoldingDataNotFound")
          ) {
            sessionStorage.removeItem("asdfMFCdsfk*jf#CeDKF=");
            this.BindSingleMobileNumber();
          } else {
            sessionStorage.removeItem("asdfMFCdsfk*jf#CeDKF=");
            console.log(
              "MFCentral RedirectSessionData: " +
                this.EncrdecrService.getDecr(
                  sessionStorage.getItem("asdfMFCdsfk*jf#CeDKF=")
                )
            );
          }
        } else {
          //Session set on business-snapshot-client component for MF Central
          if (
            !isNullOrUndefined(sessionStorage.getItem("asdfMFCFSdfsd*$&==")) &&
            sessionStorage.getItem("asdfMFCFSdfsd*$&==") != ""
          ) {
            let Redirectpage = this.EncrdecrService.getDecr(
              sessionStorage.getItem("asdfMFCFSdfsd*$&==")
            );
            if (
              Redirectpage &&
              (Redirectpage.includes("snapshot") ||
                Redirectpage == "business-snapshotRedirect")
            ) {
              // sessionStorage.removeItem("asdfMFCFSdfsd*$&==");
              this.GetHoldingDetails();
            }
          }
          console.log(
            "MFCentral RedirectSessionData: " +
              this.EncrdecrService.getDecr(
                sessionStorage.getItem("asdfMFCdsfk*jf#CeDKF=")
              )
          );
          console.log(
            "MFCentral RedirectPage: " +
              this.EncrdecrService.getDecr(
                sessionStorage.getItem("asdfMFCFSdfsd*$&==")
              )
          );
        }
      } else {
        console.log("usertype not found.");
      }
    }
  }

  ngAfterViewInit() {
    $(".SelectMobile").select2({
      placeholder: "Enter Mobile Number",
      minimumResultsForSearch: -1,
    });

    $(".SelectMobile")
      .select2()
      .on("change", (e: any) =>
        this.GetMobileForm.controls["MobileNo"].setValue(e.target.value)
      );

    $(".SelectUpdateMobile").select2({
      minimumResultsForSearch: -1,
    });

    $(".SelectUpdateMobile")
      .select2({ tags: true })
      .on("change", (e: any) => this.getDDMobile(e));

    $(".CustomSelectFamily").on("change", (e: any) =>
      this.AddFamilyMemberForm.controls["FamilyName"].setValue(e.target.value)
    );
    $(".CustomSelectInvestor").on("change", (e: any) =>
      this.AddFamilyMemberForm.controls["FamilyInvestorName"].setValue(
        e.target.value
      )
    );
    $(".CustomSelectRelation").on("change", (e: any) =>
      this.AddFamilyMemberForm.controls["FamilyInvRelation"].setValue(
        e.target.value
      )
    );
    $("#btnZone").on("click", (e: any) => this.BindRegion());
    $("#btnRegion").on("click", (e: any) => this.BindBranch());
    $("#btnBranch").on("click", (e: any) => this.BindEmployee());
    $("#btnEmployee").on("click", (e: any) => this.BindSubBroker());
    $("#btnSubBroker").on("click", (e: any) => this.BindSBClient());
    $("#btnFamily").on("click", (e: any) => this.BindClient());
    $("#btnClient").on("click", (e: any) => this.BindClientToForm());
    $("#btnEmpClient").on("click", (e: any) => this.BindEmpClientToForm());
    $(".SelectFamilyType").on("change", (e: any) => this.onChnageFamilyType(e));
    $(".CustomSelect0").on("change", (e: any) => this.onChnageClient(e));
  }

  get MobForm() {
    return this.GetMobileForm.controls;
  }

  get r() {
    return this.UpdateMobileForm.controls;
  }

  getDDMobile(e: any) {
    debugger;
    let x = e.target[e.target.selectedIndex].label;
    var charCode = x.which ? x.which : x.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
    } else {
      var EditMobilenumber = e.target.value;
      this.UpdateMobileForm.controls["UpdateMob"].setValue(EditMobilenumber);
      console.log(EditMobilenumber);
    }
  }

  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  OnMobileUpdate() {
    $("#TrackPopUp").modal("hide");
    $("#UpdateMobilePopUp").modal({ backdrop: "static", keyboard: false });
  }

  closePopup() {
    $("#TrackPopUp").modal("hide");
    $("#AlertPopUpMFCentral").modal("hide");
    $("#UpdateMobilePopUp").modal("hide");
    $("#AlertPopUp").modal("hide");
  }

  //Enter only number
  ValidatePattern(flag, e) {
    if (flag == "Number") {
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
  }

  onChangeTab(para: string) {
    switch (para) {
      case "ALL":
        window.scrollTo(0, 0);
        this.IsAll = true;
        this.IsJM = false;
        this.IsExternal = false;
        // this.ViewMoreClosed();
        break;
      case "JM":
        window.scrollTo(0, 0);
        this.IsJM = true;
        this.IsExternal = false;
        this.IsAll = false;
        // this.ViewMoreClosed();
        break;
      case "External":
        window.scrollTo(0, 0);
        this.IsExternal = true;
        this.IsAll = false;
        this.IsJM = false;
        // this.ViewMoreClosed();
        break;
    }
  }

  toggleCollapse(contentId, buttonId) {
    debugger;
    var content = document.getElementById(contentId);
    var button = document.getElementById(buttonId);

    if (content.classList.contains("expanded")) {
      content.classList.remove("expanded");
      content.classList.add("collapse");
      button.innerHTML = "&nbsp; &nbsp;Show More &nbsp;";
    } else {
      content.classList.remove("collapse");
      content.classList.add("expanded");
      button.innerHTML = "&nbsp; &nbsp;Show Less &nbsp;";
    }
  }

  toggleCollapseWeb(index: number) {
    if (this.currentIndex === index) {
      this.currentIndex = null;
    } else {
      this.currentIndex = index;
    }
  }

  isCollapsed(index: number): boolean {
    return this.currentIndex === index;
  }

  resetCollapse() {
    this.currentIndex = null;
  }

  EditMobile() {
    this.Loader.show();
    this.UpdateMobFormSubmit = false;
    $("#TrackPopUp").modal("hide");
    this.BindMobileNumber();
    this.UpdateMobileForm.controls["UpdateMob"].setValue("");
  }

  OnSubmitUpdateMobile() {
    debugger;
    this.UpdateMobFormSubmit = true;
    if (this.UpdateMobileForm.invalid) {
      return;
    } else {
      $("#UpdateMobilePopUp").modal("hide");
      this.MobileNo = "";
      this.MaskingMobileNo = "";
      let MobileDropdownvalue =
        this.UpdateMobileForm.controls["UpdateMob"].value;
      if (
        MobileDropdownvalue.includes("-") &&
        MobileDropdownvalue.split("-")[0].trim()
      ) {
        if (
          MobileDropdownvalue.includes("-") &&
          MobileDropdownvalue.split("-")[1].trim()
        ) {
          this.MobileNo = MobileDropdownvalue.split("-")[0].trim();
          this.clientemail = MobileDropdownvalue.split("-")[1].trim();
        } else {
          this.MobileNo = MobileDropdownvalue.split("-")[0].trim();
        }
      } else {
        this.MobileNo = MobileDropdownvalue.trim();
      }

      if (this.MobileNo) {
        this.MaskingMobileNo = this.ValueMasking(this.MobileNo, "Mobile");
        this.MobileNo = this.UpdateMobileForm.controls["UpdateMob"].value;
        this.OpenMobModal();
      } else {
        this.Loader.hide();
        this.CallAlertModal("MobileNumber Not Found.");
      }
    }
  }

  // Get Holding Data From Our Database
  GetHoldingDetails() {
    debugger;
    this.Loader.show();

    const json = {
      TransType: "SELECT",
      clientId: this.G_ClientBasicInfoId,
      pan: this.ClientPan,
      mobile: this.MobileNo,
    };

    let data = JSON.stringify(json);
    this.DashboardNewService.GetTransSummaryHoldingDetails(data).subscribe(
      (res: any) => {
        debugger;
        if (res.Code == 200) {
          if (
            res.ArrayOfResponse != null &&
            res.ArrayOfResponse != "" &&
            res.ArrayOfResponse1 != null &&
            res.ArrayOfResponse1 != ""
          ) {
            debugger;
            this.Loader.hide();

            this.ExportToPDFALLFundData = [];
            this.ExportToPDFJMData = [];
            this.ExportToPDFHeldAwayData = [];
            this.ExportToExcelALLFundData = [];
            this.ExportToExcelJMData = [];
            this.ExportToExcelHeldAwayData = [];

            this.ExportToExcelALLFundData_EMP = [];
            this.ExportToExcelJMData_EMP = [];
            this.ExportToExcelHeldAwayData_EMP = [];
            this.ExportToPDFALLFundData_EMP = [];
            this.ExportToPDFJMData_EMP = [];
            this.ExportToPDFHeldAwayData_EMP = [];

            // Snap shot data getting Start...
            this.SelectedUniPFData = [];
            this.SelectedUniPFData = res.ArrayOfResponse;
            if (this.SelectedUniPFData && this.SelectedUniPFData.length > 0) {
              ///All fund Snapshot Data Array
              this.AllFundSnapShotDetails = [];
              this.AllFundSnapShotDetails = this.SelectedUniPFData.filter(
                (e) => e.Type == "AllFund"
              );

              if (
                this.AllFundSnapShotDetails &&
                this.AllFundSnapShotDetails.length > 0
              ) {
                this.AllFundPurchaseValue =
                  this.AllFundSnapShotDetails[0].InvestedValue;
                this.AllFundCurrentValue =
                  this.AllFundSnapShotDetails[0].CurrentValue;
                this.AllFundAbcReturnValue =
                  this.AllFundSnapShotDetails[0].AbsReturn;
                this.AllFundXIRRValue = this.AllFundSnapShotDetails[0].XIRR;
                this.AllFundGainLoss = this.AllFundSnapShotDetails[0].GainLoss;
                this.AllFundAsOnDateBinding =
                  this.AllFundSnapShotDetails[0].lastNavDate;
              }

              ///JM Snapshot Data Array
              this.JMSnapShotDetails = [];
              this.JMSnapShotDetails = this.SelectedUniPFData.filter(
                (e) => e.Type == "JMRecomm"
              );

              if (this.JMSnapShotDetails && this.JMSnapShotDetails.length > 0) {
                this.JMPurchaseValue = this.JMSnapShotDetails[0].InvestedValue;
                this.JMCurrentValue = this.JMSnapShotDetails[0].CurrentValue;
                this.JMAbcReturnValue = this.JMSnapShotDetails[0].AbsReturn;
                this.JMXIRRValue = this.JMSnapShotDetails[0].XIRR;
                this.JMGainLoss = this.JMSnapShotDetails[0].GainLoss;
                this.JMAsOnDateBinding = this.JMSnapShotDetails[0].lastNavDate;
              }

              ///Held Away Snapshot Data Array
              this.HeldAwaySnapShotDetails = [];
              this.HeldAwaySnapShotDetails = this.SelectedUniPFData.filter(
                (e) => e.Type == "HeldAway"
              );

              if (
                this.HeldAwaySnapShotDetails &&
                this.HeldAwaySnapShotDetails.length > 0
              ) {
                this.HeldAwayPurchaseValue =
                  this.HeldAwaySnapShotDetails[0].InvestedValue;
                this.HeldAwayCurrentValue =
                  this.HeldAwaySnapShotDetails[0].CurrentValue;
                this.HeldAwayAbcReturnValue =
                  this.HeldAwaySnapShotDetails[0].AbsReturn;
                this.HeldAwayXIRRValue = this.HeldAwaySnapShotDetails[0].XIRR;
                this.HeldAwayGainLoss =
                  this.HeldAwaySnapShotDetails[0].GainLoss;
                this.HeldAwayAsOnDateBinding =
                  this.HeldAwaySnapShotDetails[0].lastNavDate;
              }
            }
            // Snap shot data getting End

            debugger;
            // All scheme data getting Start...
            this.SelectedAllUniversalPortFolioHoldingData = [];
            this.SelectedAllUniversalPortFolioHoldingData =
              res.ArrayOfResponse1;
            if (
              this.SelectedAllUniversalPortFolioHoldingData != null &&
              this.SelectedAllUniversalPortFolioHoldingData.length > 0
            ) {
              debugger;
              ///All fund scheme data Array
              this.AllFundAllSchemeListDetails = [];
              this.AllFundAllSchemeListDetails =
                this.SelectedAllUniversalPortFolioHoldingData.filter(
                  (e) => e.Type == "AllFund"
                );

              //All Fund for Export To Excel & PDF
              let temparrayALLSchemeList = [];

              let ArrTempALLSchemeListData = this.AllFundAllSchemeListDetails;
              ArrTempALLSchemeListData.map((arr: any, index: number) => {
                ////////
                //Table 1
                if (this.UserType == "1") {
                  let SingleData = [index + 1, arr.ISIN, arr.Quantity];

                  this.ExportToExcelALLFundData_EMP.push(SingleData);
                  this.ExportToPDFALLFundData_EMP.push(SingleData);
                } else {
                  let SingleData = [
                    index + 1,
                    arr.schemeName,
                    parseFloat(arr.InvestedValue).toFixed(2),
                    parseFloat(arr.CurrentValue).toFixed(2),
                    parseFloat(arr.GainLoss).toFixed(2),
                    parseFloat(arr.XIRR).toFixed(2),
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                  ];
                  temparrayALLSchemeList.push(SingleData);

                  let singledataExcel = [
                    index + 1,
                    arr.schemeName,
                    parseFloat(arr.InvestedValue).toFixed(2),
                    parseFloat(arr.CurrentValue).toFixed(2),
                    parseFloat(arr.GainLoss).toFixed(2),
                    parseFloat(arr.XIRR).toFixed(2),
                  ];
                  this.ExportToExcelALLFundData.push(singledataExcel);
                }

                let singledataPDF = [
                  index + 1,
                  arr.schemeName,
                  parseFloat(arr.InvestedValue).toFixed(2),
                  parseFloat(arr.CurrentValue).toFixed(2),
                  parseFloat(arr.GainLoss).toFixed(2),
                  parseFloat(arr.XIRR).toFixed(2),
                ];
                this.ExportToPDFALLFundData.push(singledataPDF);
              });

              this.ExportToExcelALLFundData.push([
                "",
                "Total",
                parseFloat(this.AllFundPurchaseValue).toFixed(2),
                parseFloat(this.AllFundCurrentValue).toFixed(2),
                parseFloat(this.AllFundGainLoss).toFixed(2),
                parseFloat(this.AllFundAbcReturnValue).toFixed(2),
                "Total",
              ]);
              this.ExportToPDFALLFundData.push([
                "",
                "Total",
                parseFloat(this.AllFundPurchaseValue).toFixed(2),
                parseFloat(this.AllFundCurrentValue).toFixed(2),
                parseFloat(this.AllFundGainLoss).toFixed(2),
                parseFloat(this.AllFundAbcReturnValue).toFixed(2),
              ]);
              // End

              ///JM all scheme data Array
              this.JMAllSchemeListDetails = [];
              this.JMAllSchemeListDetails =
                this.SelectedAllUniversalPortFolioHoldingData.filter(
                  (e) => e.Type == "JMRecomm"
                );

              //JM Export To EXCEL & PDF
              let ArrTempAUSchemeListData = this.JMAllSchemeListDetails;
              ArrTempAUSchemeListData.map((arr: any, index: number) => {
                ////////

                if (this.UserType == "1") {
                  let SingleData = [index + 1, arr.ISIN, arr.Quantity];

                  this.ExportToExcelJMData_EMP.push(SingleData);
                  this.ExportToPDFJMData_EMP.push(SingleData);
                } else {
                  temparrayALLSchemeList[index][7] = arr.schemeName;
                  temparrayALLSchemeList[index][8] = parseFloat(
                    arr.InvestedValue
                  ).toFixed(2);
                  temparrayALLSchemeList[index][9] = parseFloat(
                    arr.CurrentValue
                  ).toFixed(2);
                  temparrayALLSchemeList[index][10] = parseFloat(
                    arr.GainLoss
                  ).toFixed(2);
                  temparrayALLSchemeList[index][11] = parseFloat(
                    arr.XIRR
                  ).toFixed(2);

                  let singledataExcel = [
                    index + 1,
                    arr.schemeName,
                    parseFloat(arr.InvestedValue).toFixed(2),
                    parseFloat(arr.CurrentValue).toFixed(2),
                    parseFloat(arr.GainLoss).toFixed(2),
                    parseFloat(arr.XIRR).toFixed(2),
                  ];
                  this.ExportToExcelJMData.push(singledataExcel);
                }

                let singledataPDF = [
                  index + 1,
                  arr.schemeName,
                  parseFloat(arr.InvestedValue).toFixed(2),
                  parseFloat(arr.CurrentValue).toFixed(2),
                  parseFloat(arr.GainLoss).toFixed(2),
                  parseFloat(arr.XIRR).toFixed(2),
                ];
                this.ExportToPDFJMData.push(singledataPDF);
              });
              //END

              this.ExportToExcelJMData.push([
                "",
                "Total",
                parseFloat(this.JMPurchaseValue).toFixed(2),
                parseFloat(this.JMCurrentValue).toFixed(2),
                parseFloat(this.JMGainLoss).toFixed(2),
                parseFloat(this.JMAbcReturnValue).toFixed(2),
                "Total",
              ]);
              this.ExportToPDFJMData.push([
                "",
                "Total",
                parseFloat(this.JMPurchaseValue).toFixed(2),
                parseFloat(this.JMCurrentValue).toFixed(2),
                parseFloat(this.JMGainLoss).toFixed(2),
                parseFloat(this.JMAbcReturnValue).toFixed(2),
              ]);

              ////Held Away all scheme data Array
              this.HeldAwayAllSchemeListDetails = [];
              this.HeldAwayAllSchemeListDetails =
                this.SelectedAllUniversalPortFolioHoldingData.filter(
                  (e) => e.Type == "HeldAway"
                );

              //Export To Excel & PDF
              let ArrTempExternalSchemeListData =
                this.HeldAwayAllSchemeListDetails;
              ArrTempExternalSchemeListData.map((arr: any, index: number) => {
                ////////
                //Table
                if (this.UserType == "1") {
                  let SingleData = [index + 1, arr.ISIN, arr.Quantity];

                  this.ExportToExcelHeldAwayData_EMP.push(SingleData);
                  this.ExportToPDFHeldAwayData_EMP.push(SingleData);
                } else {
                  temparrayALLSchemeList[index][13] = arr.schemeName;
                  temparrayALLSchemeList[index][14] = parseFloat(
                    arr.InvestedValue
                  ).toFixed(2);
                  temparrayALLSchemeList[index][15] = parseFloat(
                    arr.CurrentValue
                  ).toFixed(2);
                  temparrayALLSchemeList[index][16] = parseFloat(
                    arr.GainLoss
                  ).toFixed(2);
                  temparrayALLSchemeList[index][17] = parseFloat(
                    arr.XIRR
                  ).toFixed(2);

                  let singledataExcel = [
                    index + 1,
                    arr.schemeName,
                    parseFloat(arr.InvestedValue).toFixed(2),
                    parseFloat(arr.CurrentValue).toFixed(2),
                    parseFloat(arr.GainLoss).toFixed(2),
                    parseFloat(arr.XIRR).toFixed(2),
                  ];
                  this.ExportToExcelHeldAwayData.push(singledataExcel);
                }
                let singledataPDF = [
                  index + 1,
                  arr.schemeName,
                  parseFloat(arr.InvestedValue).toFixed(2),
                  parseFloat(arr.CurrentValue).toFixed(2),
                  parseFloat(arr.GainLoss).toFixed(2),
                  parseFloat(arr.XIRR).toFixed(2),
                ];
                this.ExportToPDFHeldAwayData.push(singledataPDF);
              });
              //END
              this.ExportToExcelHeldAwayData.push([
                "",
                "Total",
                parseFloat(this.HeldAwayPurchaseValue).toFixed(2),
                parseFloat(this.HeldAwayCurrentValue).toFixed(2),
                parseFloat(this.HeldAwayGainLoss).toFixed(2),
                parseFloat(this.HeldAwayXIRRValue).toFixed(2),
                "Total",
              ]);
              this.ExportToPDFHeldAwayData.push([
                "",
                "Total",
                parseFloat(this.HeldAwayPurchaseValue).toFixed(2),
                parseFloat(this.HeldAwayCurrentValue).toFixed(2),
                parseFloat(this.HeldAwayGainLoss).toFixed(2),
                parseFloat(this.HeldAwayXIRRValue).toFixed(2),
              ]);

              //For PDF Total
              this.ExportToPDFData[0] = [];
              this.ExportToPDFData[1] = [];
              this.ExportToPDFData[2] = [];
              this.ExportToPDFData[0] = this.ExportToPDFALLFundData;
              this.ExportToPDFData[1] = this.ExportToPDFJMData;
              this.ExportToPDFData[2] = this.ExportToPDFHeldAwayData;

              //For Excel Total
              temparrayALLSchemeList.push([
                "",
                "Total",
                parseFloat(this.AllFundPurchaseValue).toFixed(2),
                parseFloat(this.AllFundCurrentValue).toFixed(2),
                parseFloat(this.AllFundGainLoss).toFixed(2),
                parseFloat(this.AllFundAbcReturnValue).toFixed(2),
                ,
                "Total",
                parseFloat(this.JMPurchaseValue).toFixed(2),
                parseFloat(this.JMCurrentValue).toFixed(2),
                parseFloat(this.JMGainLoss).toFixed(2),
                parseFloat(this.JMAbcReturnValue).toFixed(2),
                ,
                "Total",
                parseFloat(this.HeldAwayPurchaseValue).toFixed(2),
                parseFloat(this.HeldAwayCurrentValue).toFixed(2),
                parseFloat(this.HeldAwayGainLoss).toFixed(2),
                parseFloat(this.HeldAwayXIRRValue).toFixed(2),
              ]); //, this.G_XIRR, this.G_XIRR,"Total"]);
              this.ExportToExcelData = temparrayALLSchemeList;
            }
          } else {
            this.Loader.hide();
            if (this.UserType == "1") {
              if (this.IsUpdateHolding == true) {
                this.CallAlertModalCommon("Data not found.");
              } else {
                this.CallAlertModal("Data not found.");
              }
            } else {
              if (this.IsUpdateHolding == true) {
                this.CallAlertModalCommon("Data not found.");
              } else {
                this.CallAlertModal("Data not found.");
              }
            }
          }
        } else {
          this.Loader.hide();
          if (this.UserType == "1") {
            if (this.IsUpdateHolding == true) {
              this.CallAlertModalCommon(
                "Something went to wrong please try after sometime. "
              );
            } else {
              this.CallAlertModal(
                "Something went to wrong please try after sometime. "
              );
            }
          } else {
            if (this.IsUpdateHolding == true) {
              this.CallAlertModalCommon(
                "Something went to wrong please try after sometime. "
              );
            } else {
              this.CallAlertModal(
                "Something went to wrong please try after sometime. "
              );
            }
          }
        }
      },
      (err: any) => {
        this.Loader.hide();
        console.log(err);
      }
    );
  }

  GoToDashboard() {
    debugger;
    $(".modal").modal("hide");
    $("#OTPPopUp").modal("hide");
    $("#TrackPopUp").modal("hide");
    $("#AlertPopUpMFCentral").modal("hide");
    $("#UpdateMobilePopUp").modal("hide");
    $("#AlertPopUp").modal("hide");
    $("#EmpFilterModalMFCentral").modal("hide");

    if (this.UserType == "1") {
      if (!this.IsUpdateHolding) {
        // this.router.navigate(['/mf-dashboard'], { relativeTo: this.route });
        this.router.navigate(["/dashboard"], { relativeTo: this.route });
      } else {
        this.router.navigate(["/mf-central"], { relativeTo: this.route });
      }
    } else if (this.UserType == "3") {
      if (this.IsUpdateHolding) {
        this.router.navigate(["/mf-central"], { relativeTo: this.route });
      } else {
        this.router.navigate(["/dashboard"], { relativeTo: this.route });
      }
    } else if (this.UserType == "2") {
      if (this.IsUpdateHolding) {
        this.router.navigate(["/mf-central"], { relativeTo: this.route });
      } else {
        this.router.navigate(["/dashboard"], { relativeTo: this.route });
      }
    } else {
      if (this.IsUpdateHolding) {
        this.router.navigate(["/mf-central"], { relativeTo: this.route });
      } else {
        this.router.navigate(["/dashboard"], { relativeTo: this.route });
      }
    }
  }

  CallAlertModal(msg: any) {
    $("#AlertPopUpMFCentral").modal({
      backdrop: "static",
      keyboard: false,
    });
    $("#AlertModalContentMsg").text(msg);
  }

  CallAlertModalCommon(msg: any) {
    $("#AlertPopUp").modal({
      backdrop: "static",
      keyboard: false,
    });
    $("#ShowAlertModalContentMsg").text(msg);
  }

  OpenOTPModel() {
    debugger;
    this.GetMobileFormSubmit = true;
    if (this.GetMobileForm.invalid) {
      return;
    } else {
      debugger;
      $("#MobileNoSelection_Modal").modal("hide");
      this.MobileNo = "";
      this.MaskingMobileNo = "";

      let MobileDropdownvalue = this.GetMobileForm.controls["MobileNo"].value;
      this.MobileNo = MobileDropdownvalue.split("-")[0].trim();
      this.clientemail = MobileDropdownvalue.split("-")[1].trim();

      this.MaskingMobileNo = this.ValueMasking(this.MobileNo, "Mobile");
      //Mobile No Session Add Because E-Cas Update Holding Details Get Use
      sessionStorage.setItem(
        "M5s&%dfeO*BadIafL%E2",
        this.EncrdecrService.setEncr(this.MobileNo)
      );
      console.log("Selected mobile no:------->" + this.MobileNo);
      this.OpenTrackPopupModal();
    }
  }

  ValueMasking(value, Flag) {
    let MaskValue = "";
    if (Flag == "Mobile") {
      if(value && !isNullOrUndefined(value) && value != "")
      {
        MaskValue = value.replace(/\d(?=\d{4})/g, "X");
      }
    } else if (Flag == "Email") {
      if(value && !isNullOrUndefined(value) && value != "" )  
      {
        let index = value.indexOf("@");
        MaskValue =
          value.substring(0, 2) +
          "XXXXXXXX" +
          value.substring(index, value.length); //- 1
      }
    }
    return MaskValue;
  }

  //Get Client Mobile number
  BindMobileNumber() {
    debugger;
    this.Loader.show();
    let data = {
      clientId: this.G_ClientBasicInfoId,
      TransType: "ClientContactDataForMFCentral",
    };
    debugger;
    this.DashboardNewService.getClientContactData(data).subscribe(
      (data: any) => {
        if (
          data.Message != null &&
          data.Message != "" &&
          data.Message.indexOf("Not Authorized") > -1
        ) {
          this.Loader.hide();
          return;
        } else {
          if (data && data.ArrayOfResponse && data.ArrayOfResponse.length > 0) {
            debugger;
            this.MobileNo = "";
            this.SelectedMobileNumbers = [];
            debugger;
            let mobileEmailDropDownData = data.ArrayOfResponse;
            mobileEmailDropDownData.map((arr: any, index: number) => {
              if (arr.TEXTFIELD && arr.VALUEFIELD) {
                let mobileEmailDD = {};
                debugger;
                if (
                  arr.TEXTFIELD.includes("-") &&
                  arr.TEXTFIELD.split("-")[0].trim()
                ) {
                  if (
                    arr.TEXTFIELD.includes("-") &&
                    arr.TEXTFIELD.split("-")[1].trim()
                  ) {
                    mobileEmailDD = {
                      OrignalValue: arr.VALUEFIELD,
                      MaskValue:
                        this.ValueMasking(
                          arr.TEXTFIELD.split("-")[0].trim(),
                          "Mobile"
                        ) +
                        " - " +
                        arr.TEXTFIELD.split("-")[1].trim(),
                    };
                  } else {
                    mobileEmailDD = {
                      OrignalValue: arr.VALUEFIELD,
                      MaskValue: this.ValueMasking(
                        arr.TEXTFIELD.split("-")[0].trim(),
                        "Mobile"
                      ),
                    };
                  }
                }
                this.SelectedMobileNumbers.push(mobileEmailDD);
              }
            });
            this.Loader.hide();
            $("#UpdateMobilePopUp").modal({
              backdrop: "static",
              keyboard: false,
            });
          } else {
            this.Loader.hide();
            this.CallAlertModal("Mobile number is not available to this PAN.");
          }
        }
      },
      (err) => {
        console.log(err);
        this.Loader.hide();
        this.CallAlertModal("Something went wrong please try again.");
      }
    );
  }

  BindSingleMobileNumber() {
    debugger;
    this.GetMobileFormSubmit = false;
    this.GetMobileForm.controls["MobileNo"].setValue("");
    this.Loader.show();
    let data = {
      clientId: this.G_ClientBasicInfoId,
      TransType: "ClientContactDataForMFCentralSingle",
    };
    debugger;
    this.DashboardNewService.getClientContactData(data).subscribe(
      (data: any) => {
        if (
          data.Message != null &&
          data.Message != "" &&
          data.Message.indexOf("Not Authorized") > -1
        ) {
          this.Loader.hide();
          return;
        } else {
          this.Loader.hide();
          if (data && data.ArrayOfResponse && data.ArrayOfResponse.length > 0) {
            if (
              data.ArrayOfResponse[0].VALUEFIELD &&
              data.ArrayOfResponse.length > 0
            ) {
              this.MobileNo = "";
              this.MobileNo = data.ArrayOfResponse[0].VALUEFIELD;
              this.MaskingMobileNo = "";
              this.MaskingMobileNo = this.ValueMasking(
                data.ArrayOfResponse[0].VALUEFIELD,
                "Mobile"
              );
              //Mobile No Session Add Because E-Cas Update Holding Details Get Use
              sessionStorage.setItem(
                "M5s&%dfeO*BadIafL%E2",
                this.EncrdecrService.setEncr(this.MobileNo)
              );
              this.OpenTrackPopupModal();
            } else {
              debugger;
              this.Loader.hide();
              this.CallAlertModal(
                "Mobile number is not available to this PAN."
              );
            }
          } else {
            this.Loader.hide();
            this.CallAlertModal("Mobile number is not available to this PAN.");
          }
        }
      },
      (err) => {
        console.log(err);
        this.Loader.hide();
      }
    );
  }

  OpenTrackPopupModal() {
    $("#TrackPopUp").modal("hide");
    $("#OTPPopUp").modal("hide");
    $("#MFCentralModalLoader").modal("hide");
    $("#TrackPopUp").modal({
      backdrop: "static",
      keyboard: false,
    });
  }

  OpenMobModal() {
    debugger;
    this.Loader.show();

    console.log("MF Central Pan---->" + this.ClientPan);
    console.log("MF Central email---->" + this.clientemail);

    let CheckReqHitCountJson = {
      TransType: "SELECT",
      pan: this.ClientPan,
      mobile: this.MobileNo,
      clientId: this.G_ClientBasicInfoId,
      EMPId:
        this.UserType == 1
          ? this.EmpID
          : this.UserType == 2
          ? this.SubbrokerID
          : "", // usertype emp then employee id and subbroker then subbroker id
      WealthSpecListFlag: "",
      ReqHitBy:
        this.UserType == 1
          ? "Employee"
          : this.UserType == 2
          ? "Subbroker"
          : "Client",
    };
    debugger;

    //Request hit count check
    this.DashboardNewService.GetReqHitCountCheckDet(
      CheckReqHitCountJson
    ).subscribe(
      (ReqHitResult: any) => {
        debugger;
        console.log(
          "Request Hit Result Message---->" +
            ReqHitResult.Message +
            " Code: " +
            ReqHitResult.Code
        );

        if (
          ReqHitResult != null &&
          ReqHitResult.Code == 200 &&
          ReqHitResult.Message == "Success"
        ) {
          let ClientRefNo = this.ClientPan + Date.now(); //pan + Current Timestamp Concated
          console.log("ClientRefNo:----------->" + ClientRefNo);

          const currentDate = new Date();
          let ToDate = this.datePipe.transform(currentDate, "dd-MMM-YYYY");

          //Send OTP MFCentral
          let OTPSendRequestJson = {
            clientRefNo: ClientRefNo,
            reqId: "",
            pan: this.ClientPan,
            mobile: this.MobileNo,
            pekrn: "",
            email: "",
            fromDate: "01-Jan-1900",
            toDate: ToDate,
          };
          debugger;
          this.DashboardNewService.sendOTPMFCentral(
            OTPSendRequestJson
          ).subscribe(
            (SendOTPResp: any) => {
              debugger;
              console.log(
                "Send OTP Response Message---->" +
                  SendOTPResp.Message +
                  " Code: " +
                  SendOTPResp.Code
              );

              if (
                SendOTPResp &&
                SendOTPResp.Code == 200 &&
                SendOTPResp.Message == "Success"
              ) {
                this.OtpSendResponse = [];
                this.OtpSendResponse[0] = SendOTPResp.ArrayOfResponse[0];
                this.Loader.hide();
                this.OpenOTPInputModal();
              } else {
                this.Loader.hide();
                if (
                  SendOTPResp.Code == 422 &&
                  SendOTPResp.Message ==
                    "Invalid PAN/PEKRN, Mobile/Email combination"
                ) {
                  this.alertheader = "Alert!";
                  this.CallAlertModal(
                    "We are unable to fetch details for the Mobile number and PAN combination. Request you please verify the details and try again"
                  );
                } else {
                  this.CallAlertModal(SendOTPResp.Message);
                }
              }
            },
            (err) => {
              console.log(err);
              this.Loader.hide();
            }
          );
        } else {
          this.Loader.hide();
          this.alertheader = "Alert!";
          this.CallAlertModal(ReqHitResult.Message);
        }
      },
      (err) => {
        console.log(err);
        this.Loader.hide();
      }
    );
  }

  OpenOTPInputModal() {
    this.ngOtpInput.setValue("");
    this.OTPForm.controls["OTP"].setValue("");

    $("#TrackPopUp").modal("hide");
    $("#OTPPopUp").modal({
      backdrop: "static",
      keyboard: false,
    });
    this.StartTimer();
  }

  @HostListener("keypress", ["$event"])
  keypressnumber(event: KeyboardEvent, Flag: any) {
    // Prevent non-numeric input.
    if (Flag == "OTP") {
      if (event.key && !/^\d*$/.test(event.key)) {
        event.preventDefault();
      }
    }
  }

  onOtpChange(e) {
    debugger;
    let val = e;
    let v = "";
    v = v + val;
    this.OTPForm.controls["OTP"].setValue(v);
    console.log(this.OTPForm.controls["OTP"].value);
    $("#OTPBox .ng-otp-input-wrapper .OTPBox").removeClass("OTPFailed");
    this.IsVerify = false;
    // this.VerifyStatus = false;
    // this.OTPVerified = false;
  }

  StartTimer() {
    debugger;
    this.IsVerify = false;
    $("#ResendBtn").removeClass("RedClr");
    $("#ResendBtn").addClass("disabled-link");

    let t = this.OtpTimer;
    this.OTP_Timer_Function = setInterval(function () {
      //
      if (t >= 0) {
        const minutes = Math.floor(t / 60);
        let seconds: any = t % 60;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }

        $("#Time").text(`0${minutes}:${seconds}`);
        if (t == 0) {
          $("#ResendBtn").addClass("RedClr");
          $("#ResendBtn").removeClass("disabled-link");
        }
        t -= 1;
      }
    }, 1000);
  }

  ClearIntervalOTP() {
    debugger;
    $("#OTPPopUp").modal("hide");
    this.GoToDashboard();
    $("#Time").text(this.OtpTimeRemening);
    clearInterval(this.OTP_Timer_Function);

    this.ngOtpInput.setValue("");
    this.OTPForm.controls["OTP"].setValue("");
    $("#ResendBtn").removeClass("RedClr");
    $("#ResendBtn").addClass("disabled-link");
  }

  ResendOTP() {
    this.ClearIntervalOTP();
    this.ngOtpInput.setValue("");
    this.OTPForm.controls["OTP"].setValue("");
    this.OpenMobModal();
    // this.StartTimer();
    $("#ResendBtn").removeClass("RedClr");
    $("#ResendBtn").addClass("disabled-link");
  }

  OtpModalClosed() {
    debugger;
    // this.closeOTPModal = true;
    $("#OTPPopUp").modal("hide");
    $(".modal").modal("hide");
    // $('.modal').remove(); all modal hide code
    // $('.modal-backdrop').remove();
    $("body").removeClass("modal-open");
    this.ClearIntervalOTP();
    this.ngOtpInput.setValue("");
    this.OTPForm.controls["OTP"].setValue("");
  }

  OnVerify() {
    debugger;
    if (this.OTPForm.invalid) {
      this.IsVerify = true;
      return;
    } else {
      // this.VerifyStatus = true;
      $("#Verify").prop("disabled", true);

      $("#OTPPopUp").modal({
        backdrop: "static",
        keyboard: false,
      });

      if (this.OtpSendResponse && this.OtpSendResponse.length > 0) {
        debugger;
        let VerifyOTPRequestJson = {
          TransType: "OTPValidation",
          reqId: this.OtpSendResponse[0].reqId,
          otpRef: this.OtpSendResponse[0].otpRef,
          userSubjectReference: this.OtpSendResponse[0].userSubjectReference,
          clientRefNo: this.OtpSendResponse[0].clientRefNo,
          enteredOtp: this.OTPForm.controls["OTP"].value,
        };
        debugger;
        this.DashboardNewService.VerifyOTPMFCentral(
          VerifyOTPRequestJson
        ).subscribe(
          (verifyOtpResult: any) => {
            debugger;
            console.log(
              "Verify Send OTP Response Message---->" +
                verifyOtpResult.Message +
                " Code: " +
                verifyOtpResult.Code
            );

            if (
              verifyOtpResult &&
              verifyOtpResult.Code == 202 &&
              verifyOtpResult.Message == "Accepted status"
            ) {
              // this.VerifyStatus = false;
              // this.OTPVerified = true;
              $("#OTPBox .ng-otp-input-wrapper .OTPBox").addClass("OTPSuccess");
              $("#Verify").prop("disabled", false);

              // if (this.OTPVerified == true && this.IsMobile) {
              //   this.notifier.notify("success", "OTP verified successful");
              // }
              setTimeout(() => {
                $("#OTPPopUp").modal("hide");
                $("#TrackPopUp").modal("hide");
                $("#MFCentralModalLoader").modal({
                  backdrop: "static",
                  keyboard: false,
                });
              }, 1000);

              //if (this.IsMobile) {
              //this.notifier.notify("success", "OTP verified successful");
              // }
              debugger;
              setTimeout(() => {
                //Call MF Central Detailed API
                let CASStatDetReqJson = {
                  clientRefNo: this.OtpSendResponse[0].clientRefNo,
                  reqId: this.OtpSendResponse[0].reqId,
                  pan: this.ClientPan,
                  mobile: this.MobileNo,
                  email: this.clientemail,
                  clientId: this.G_ClientBasicInfoId,
                  EMPId:
                    this.UserType == 1
                      ? this.EmpID
                      : this.UserType == 2
                      ? this.SubbrokerID
                      : "",
                  ReqHitBy:
                    this.UserType == 1
                      ? "Employee"
                      : this.UserType == 2
                      ? "Subbroker"
                      : "Client",
                };

                this.DashboardNewService.CASStateDetailedMFC(
                  CASStatDetReqJson
                ).subscribe(
                  (CasStatDetResponse: any) => {
                    debugger;
                    console.log("hello investment-page page");
                    console.log(
                      "Get Data Message---->" +
                        CasStatDetResponse.Message +
                        " Code: " +
                        CasStatDetResponse.Code
                    );
                    debugger;
                    if (CasStatDetResponse && CasStatDetResponse.Code == 200) {
                      // this.IsOTPVerifiedSuccess = false;
                      $("#MFCentralModalLoader").modal("hide");
                      this.GetHoldingDetails();
                    } else if (
                      CasStatDetResponse &&
                      CasStatDetResponse.Code == 400
                    ) {
                      this.Loader.hide();
                      // this.IsOTPVerifiedSuccess = false;

                      $("#OTPPopUp").modal("hide");
                      $("#MFCentralModalLoader").modal("hide");
                      this.CallAlertModal(
                        "Something went wrong please try again."
                      );
                    } else {
                      this.Loader.hide();
                      this.IsVerify = true;
                      $("#OTPPopUp").modal("hide");
                      // this.IsOTPVerifiedSuccess = false;
                      $("#MFCentralModalLoader").modal("hide");
                      // this.CallAlertModal("We are unable to fetch your details since there are no folios mapped to your registered mobile number and PAN");
                      this.CallAlertModal(CasStatDetResponse.Message);
                    }
                  },
                  (err) => {
                    console.log(err);
                    this.Loader.hide();
                    $("#OTPPopUp").modal("hide");
                    // this.IsOTPVerifiedSuccess = false;
                    $("#MFCentralModalLoader").modal("hide");
                    this.CallAlertModal(
                      "Something went wrong please try again."
                    );
                  }
                );
              }, 34000);
            } else {
              if (
                verifyOtpResult.Code == 406 ||
                verifyOtpResult.Message.includes("incorrect")
              ) {
                $("#OTPBox .ng-otp-input-wrapper .OTPBox").addClass(
                  "OTPFailed"
                );
                $("#Verify").prop("disabled", false);
                $("#MFCentralModalLoader").modal("hide");
                // this.VerifyStatus = false;
                this.IsVerify = true;
              } else {
                $("#Verify").prop("disabled", false);
                $("#MFCentralModalLoader").modal("hide");
                // this.VerifyStatus = false;
                this.IsVerify = true;
                $("#OTPPopUp").modal("hide");
                this.CallAlertModal(verifyOtpResult.Message);
              }
            }
          },
          (err) => {
            console.log(err);
            this.Loader.hide();
            $("#OTPPopUp").modal("hide");
            this.CallAlertModal("Something went wrong please try again.");
          }
        );
      } else {
        console.log("OTP Response not found");
        this.Loader.hide();
        this.CallAlertModal("Something went wrong please try again.");
      }
    }
  }

  EditMobileModalClosed() {
    $("#UpdateMobilePopUp").modal("hide");
    this.UpdateMobFormSubmit = false;
    this.UpdateMobileForm.controls["UpdateMob"].setValue("");

    if (this.UserType == "1") {
      if (!this.IsUpdateHolding) {
        // this.router.navigate(['/mf-dashboard'], { relativeTo: this.route });
        this.router.navigate(["/dashboard"], { relativeTo: this.route });
      } else {
        this.router.navigate(["/mf-central"], { relativeTo: this.route });
      }
    } else if (this.UserType == "3") {
      if (this.IsUpdateHolding) {
        this.router.navigate(["/mf-central"], { relativeTo: this.route });
      } else {
        this.router.navigate(["/dashboard"], { relativeTo: this.route });
      }
    }
  }

  updateHoldingDetails() {
    this.IsUpdateHolding = true;
    this.Loader.show();

    let CheckReqHitCountJson = {
      TransType: "SELECT",
      pan: this.ClientPan,
      mobile: this.MobileNo,
      clientId: this.G_ClientBasicInfoId,
      EMPId:
        this.UserType == 1
          ? this.EmpID
          : this.UserType == 2
          ? this.SubbrokerID
          : "",
      WealthSpecListFlag: this.UserType == "1" ? "" : "",
      ReqHitBy:
        this.UserType == 1
          ? "Employee"
          : this.UserType == 2
          ? "Subbroker"
          : "Client",
    };
    debugger;

    //Request hit count check
    this.DashboardNewService.GetReqHitCountCheckDet(
      CheckReqHitCountJson
    ).subscribe(
      (ReqHitResult: any) => {
        debugger;
        console.log(
          "Request Hit Result Message---->" +
            ReqHitResult.Message +
            " Code: " +
            ReqHitResult.Code
        );

        if (
          ReqHitResult != null &&
          ReqHitResult.Code == 200 &&
          ReqHitResult.Message == "Success"
        ) {
          this.BindSingleMobileNumber();
        } else {
          this.Loader.hide();
          this.alertheader = "Alert!";
          this.CallAlertModal(ReqHitResult.Message);
        }
      },
      (err) => {
        console.log(err);
        this.Loader.hide();
      }
    );
  }

  onArrowClick(
    index: number,
    FctSchemeCode: string,
    Folio: string,
    ISIN: string
  ): void {
    this.toggleCollapseWeb(index);
    this.getTransDetShow(FctSchemeCode, Folio, ISIN, "");
  }

  getTransDetShow(schemecode: any, folio: any, ISIN: any, Flag: any) {
    debugger;
    this.Loader.show();
    if (schemecode && folio && ISIN) {
      this.isTrxnDetailsShowID = "";
      this.isTrxnDetailsShowID = schemecode + folio + ISIN + Flag;

      let getTransDetailJsonRequest = {
        TransType: "GETTransDet",
        pan: this.ClientPan,
        folio: folio,
        ISIN: ISIN,
        schemecode: schemecode,
      };

      this.DashboardNewService.GetTransDetailsMFCentral(
        getTransDetailJsonRequest
      ).subscribe(
        (result: any) => {
          debugger;
          this.Loader.hide();
          if (result && result.Code == 200 && result.Message == "Success") {
            if (
              result &&
              result.ArrayOfResponse &&
              result.ArrayOfResponse != "" &&
              result.ArrayOfResponse.length > 0
            ) {
              this.TrxnDetailsDataList = [];
              this.TrxnDetailsDataList = result.ArrayOfResponse;
              this.TrxnDetFolioNumber = "";
              this.TrxnDetFolioNumber = this.TrxnDetailsDataList[0].Folio;

              // this.ExportToExcelTransDetails = [];
              // this.ExportToPDFTransDetails = [];

              // let ArrTempTransDetailsData = this.TrxnDetailsDataList;
              // ArrTempTransDetailsData.map((arr: any, index: number) => {
              //   let singledata = [index + 1, arr.SchemeName, arr.Folio, arr.TrxnDate, arr.TrxnTypeFlag, parseFloat(arr.TrxnUnits).toFixed(2), parseFloat(arr.NAV).toFixed(2), parseFloat(arr.TrxnAmount).toFixed(2)]
              //   this.ExportToExcelTransDetails.push(singledata);
              //   this.ExportToPDFTransDetails.push(singledata);
              // });

              // if (Flag == "ALL") {
              //   this.IsViewMoreAll = !this.IsViewMoreAll;
              //   this.IsViewMoreAU = false;
              //   this.IsViewMoreEx = false;
              // }
              // else if (Flag == "AU") {
              //   this.IsViewMoreAU = !this.IsViewMoreAU;
              //   this.IsViewMoreAll = false;
              //   this.IsViewMoreEx = false;
              // }
              // else if (Flag == "EXT") {
              //   this.IsViewMoreEx = !this.IsViewMoreEx;
              //   this.IsViewMoreAll = false;
              //   this.IsViewMoreAU = false;
              // }
              // else {
              //   this.IsViewMoreAll = false;
              //   this.IsViewMoreAU = false;
              //   this.IsViewMoreEx = false;
              // }
            } else {
              this.ViewMoreClosed();
              this.CallAlertModalCommon("Transaction data not found.");
            }
          } else {
            this.ViewMoreClosed();
            this.CallAlertModalCommon("Transaction data not found.");
          }
        },
        (error) => {
          this.Loader.hide();
          this.ViewMoreClosed();
        }
      );
    } else {
      console.log("schemecode or folio or ISIN is null");
      this.Loader.hide();
      this.ViewMoreClosed();
      this.CallAlertModalCommon("something went to wrong. please try again.");
    }
  }

  ViewMoreClosed() {
    this.TrxnDetailsDataList = [];
    this.TrxnDetFolioNumber = "";

    this.isTrxnDetailsShowID = "";
    // this.IsViewMoreAll = false;
    // this.IsViewMoreAU = false;
    // this.IsViewMoreEx = false;
  }
  onSubmitEmpForm() {
    try {
      debugger;
      this.Loader.show();
      let usertype =
        this.UserType == 2 && this.flag == "Client" ? 1 : this.UserType;
      this.clientService
        .GetAllClientsList(this.G_LoginId, usertype, this.G_ROLEID, this.flag)
        .subscribe((response) => {
          debugger;
          $("#EmpFilterModalMFCentral").modal("hide");
          let res = JSON.parse(this.EncrdecrService.getDecr(response));
          let responseMessage = res.Message;
          if (
            responseMessage &&
            responseMessage.toLowerCase() == "not authorized"
          ) {
            this.Loader.hide();
            this.Logout.LogoutUser();
          } else {
            let EncryptedAPIResponse = res.ArrayOfResponse;
            EncryptedAPIResponse.map((arr: any, index: number) => {
              for (const [key, value] of Object.entries(arr)) {
                if (!isNullOrUndefined(value) && value != "") {
                  arr[key] = this.EncrdecrService.getDecr(value.toString());
                }
              }
            });
            this.FinalClientData = res.ArrayOfResponse;
            if (this.FinalClientData && this.FinalClientData.length > 0) {
              this.ClientName = this.FinalClientData[0].ClientName;
              this.ClientPan = this.FinalClientData[0].PANNo;
              this.MobileNo = this.FinalClientData[0].MobileNo;
              this.MaskingMobileNo = this.ValueMasking(this.MobileNo, "Mobile");
              this.clientemail = this.FinalClientData[0].EmailId;
              if (this.FinalClientData[0].clientbasicinfoid) {
                this.G_ClientBasicInfoId =
                  this.FinalClientData[0].clientbasicinfoid;
              }
              this.clientemail = this.FinalClientData[0].EmailId;

              let data = {
                clientId: this.G_ClientBasicInfoId,
                TransType: "ClientContactDataForMFCentralSingle",
              };
              debugger;
              this.Loader.show();

              this.DashboardNewService.getClientContactData(data).subscribe(
                (data: any) => {
                  if (
                    data.Message != null &&
                    data.Message != "" &&
                    data.Message.indexOf("Not Authorized") > -1
                  ) {
                    this.Loader.hide();
                    $("#EmpFilterModalMFCentral").modal("hide");
                    return;
                  } else {
                    debugger;
                    if (
                      data &&
                      data.ArrayOfResponse &&
                      data.ArrayOfResponse.length > 0
                    ) {
                      if (
                        data.ArrayOfResponse[0].VALUEFIELD &&
                        data.ArrayOfResponse.length > 0
                      ) {
                        this.MobileNo = "";
                        this.MobileNo = data.ArrayOfResponse[0].VALUEFIELD;
                        this.MaskingMobileNo = "";
                        this.MaskingMobileNo = this.ValueMasking(
                          this.MobileNo,
                          "Mobile"
                        );

                        if (data.ArrayOfResponse[0].TEXTFIELD) {
                          let result = data.ArrayOfResponse[0].TEXTFIELD;
                          if (result.includes("-")) {
                            if (result.split("-")[1].trim()) {
                              this.clientemail = result.split("-")[1].trim();
                            }
                          }
                        }
                        this.OnCheckClientHoldingDetails();
                      } else {
                        debugger;
                        $("#EmpFilterModalMFCentral").modal("hide");
                        this.Loader.hide();
                        this.CallAlertModal(
                          "Mobile number is not available to this PAN."
                        );
                      }
                    } else {
                      $("#EmpFilterModalMFCentral").modal("hide");
                      this.Loader.hide();
                      this.CallAlertModal(
                        "Mobile number is not available to this PAN."
                      );
                    }
                  }
                },
                (err) => {
                  console.log(err);
                  this.Loader.hide();
                  $("#EmpFilterModalMFCentral").modal("hide");
                  this.CallAlertModal("Something went wrong please try again.");
                }
              );
            } else {
              $("#EmpFilterModalMFCentral").modal("hide");
              this.CallAlertModal("Employee Filter Client Data not found.");
              this.Loader.hide();
            }
          }
        });
    } catch (error) {
      $("#EmpFilterModalMFCentral").modal("hide");
      this.Loader.hide();
      console.log(error);
    }
  }

  BindFilters() {
    this.IsUpdateHolding = false;
    if (this.G_ROLEID == 1) {
      let request = {
        ZONE_ID: null,
        REGION_ID: null,
        BRANCH_ID: null,
        SB_ID: null,
        EMP_ID: null,
        FAMILY_ID: null,
        CLIENT_ID: null,
      };
      const json = JSON.stringify(request);
      this.reportservice
        .BindEmployeeFilters(this.G_LoginId, this.UserType, "ZONE_LIST", json)
        .subscribe((response) => {
          let data = JSON.parse(this.EncrdecrService.getDecr(response));
          this.ZoneList = data.ArrayOfResponse;
          // this.SelectedZone = this.ZoneList;
          // this.SelectedZone.map((arr: any, index: number) => {

          // });
        });
      this.ZoneSetting = {
        singleSelection: false,
        idField: "VALUEFIELD",
        textField: "TEXTFIELD",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        itemsShowLimit: 1,
        allowSearchFilter: true,
      };
    } else {
      this.reportservice
        .GetBranchDetailsByEmpId(this.G_LoginId)
        .subscribe((data) => {
          if (data.ArrayOfResponse.length > 0) {
            if (this.G_ROLEID == 2) {
              this.ZoneResult.push(data.ArrayOfResponse[0].ZoneId);
              this.BindRegion();
            } else if (this.G_ROLEID == 3) {
              this.RegionResult.push(data.ArrayOfResponse[0].RegionId);
              this.BindBranch();
            } else if (this.G_ROLEID == 4 || this.G_ROLEID == 5) {
              this.BranchResult.push(data.ArrayOfResponse[0].BranchId);
              this.BindEmployee();
            } else if (this.G_ROLEID == 6) {
              this.EmployeeResult.push(data.ArrayOfResponse[0].EmpId);
              this.BindSubBroker();
            }
          }
        });
    }
    let request = {
      ZONE_ID: null,
      REGION_ID: null,
      BRANCH_ID: null,
      SB_ID: null,
      EMP_ID: this.G_LoginId,
      FAMILY_ID: null,
      CLIENT_ID: null,
    };
    const json = JSON.stringify(request);
    this.reportservice
      .BindEmployeeFilters(
        this.G_LoginId,
        this.UserType,
        "EMP_WISE_CLIENT",
        json
      )
      .subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));
        this.EmpClientList = data.ArrayOfResponse;
        this.ClientList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.EmpClientSetting = {
      singleSelection: true,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.ClientSetting = {
      singleSelection: true,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.OpenEMPFilterModal();
  }

  //Get Client List
  OpenEMPFilterModal() {
    debugger;
    this.isEmpSub = "";
    $("#EmpFilterModalMFCentral").modal({
      backdrop: "static",
      keyboard: false,
    });
  }

  BindRegion() {
    $("body").trigger("click");
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: null,
      BRANCH_ID: null,
      SB_ID: null,
      EMP_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null,
    };
    const json = JSON.stringify(request);
    this.SelectedRegion = [];
    this.SelectedBranch = [];
    this.SelectedEmployee = [];
    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(this.G_LoginId, this.UserType, "REGION_LIST", json)
      .subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));
        this.RegionList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.RegionSetting = {
      singleSelection: false,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  onRegionSelect(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.RegionResult.indexOf(value);
      if (i == -1) {
        this.RegionResult.push(value);
      } else {
        this.RegionResult.splice(i, 1);
      }
    }
  }
  onItemSelectDeselectAllRegion(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.RegionResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.RegionResult = [];
        break;
    }

    //alert(this.ZoneResult.toString());
    //this.BindRegion(this.ZoneResult.toString());
  }

  BindBranch() {
    $("body").trigger("click");
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: null,
      SB_ID: null,
      EMP_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null,
    };
    const json = JSON.stringify(request);

    this.SelectedBranch = [];
    this.SelectedEmployee = [];
    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(this.G_LoginId, this.UserType, "BRANCH_LIST", json)
      .subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));
        this.BranchList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.BranchSetting = {
      singleSelection: false,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onBranchSelect(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.BranchResult.indexOf(value);
      if (i == -1) {
        this.BranchResult.push(value);
      } else {
        this.BranchResult.splice(i, 1);
      }
    }
  }
  onItemSelectDeselectAllBranch(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.BranchResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.BranchResult = [];
        break;
    }

    //alert(this.ZoneResult.toString());
    //this.BindRegion(this.ZoneResult.toString());
  }
  BindEmployee() {
    $("body").trigger("click");
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID: null,
      EMP_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null,
    };
    const json = JSON.stringify(request);

    this.SelectedEmployee = [];
    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(
        this.G_LoginId,
        this.UserType,
        "BRANCH_WISE_EMP",
        json
      )
      .subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));
        this.EmployeeList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.EmployeeSetting = {
      singleSelection: false,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  onEmployeeSelect(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.EmployeeResult.indexOf(value);
      if (i == -1) {
        this.EmployeeResult.push(value);
      } else {
        this.EmployeeResult.splice(i, 1);
      }
    }
  }
  onItemSelectDeselectAllEmployee(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.EmployeeResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.EmployeeResult = [];
        break;
    }

    //alert(this.ZoneResult.toString());
    //this.BindRegion(this.ZoneResult.toString());
  }
  BindSubBroker() {
    $("body").trigger("click");
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID: null,
      EMP_ID: this.EmployeeResult.toString(),
      FAMILY_ID: null,
      CLIENT_ID: null,
    };
    const json = JSON.stringify(request);

    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(this.G_LoginId, this.UserType, "EMP_WISE_SB", json)
      .subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));
        this.SubBrokerList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.SubBrokerSetting = {
      singleSelection: false,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    let request1 = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID:
        this.SubBRokerResult.toString() != ""
          ? this.SubBRokerResult.toString()
          : null,
      EMP_ID: this.EmployeeResult.toString(),
      FAMILY_ID: null,
      CLIENT_ID: null,
    };
    const flag =
      this.SubBRokerResult.toString() != ""
        ? "SB_WISE_CLIENT"
        : "EMP_WISE_CLIENT";
    const json1 = JSON.stringify(request1);
    this.reportservice
      .BindEmployeeFilters(this.G_LoginId, this.UserType, flag, json1)
      .subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));
        this.ClientList = [];
        this.ClientList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.ClientSetting = {
      singleSelection: true,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onChnageFamilyType(e: any) {
    //////
    debugger;
    const val = e.target.value;
    this.SelectedClientList = [];
    if (val == "1") {
      this.isFamilyDisabled = true;
      let request = {
        ZONE_ID: this.ZoneResult.toString(),
        REGION_ID: this.RegionResult.toString(),
        BRANCH_ID: this.BranchResult.toString(),
        SB_ID:
          this.SubBRokerResult.toString() != ""
            ? this.SubBRokerResult.toString()
            : null,
        EMP_ID: this.EmployeeResult.toString(),
        FAMILY_ID: null,
        CLIENT_ID: null,
      };
      const flag =
        this.SubBRokerResult.toString() != ""
          ? "SB_WISE_CLIENT"
          : "EMP_WISE_CLIENT";
      const json = JSON.stringify(request);
      this.reportservice
        .BindEmployeeFilters(this.G_LoginId, this.UserType, flag, json)
        .subscribe((response) => {
          let data = JSON.parse(this.EncrdecrService.getDecr(response));
          this.ClientList = data.ArrayOfResponse;
          //  console.log(this.ClientList);
          this.Loader.hide();
        });
      this.ClientSetting = {
        singleSelection: true,
        idField: "VALUEFIELD",
        textField: "TEXTFIELD",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        itemsShowLimit: 1,
        allowSearchFilter: true,
      };
    } else {
      this.isFamilyDisabled = false;
      let request = {
        ZONE_ID: this.ZoneResult.toString(),
        REGION_ID: this.RegionResult.toString(),
        BRANCH_ID: this.BranchResult.toString(),
        SB_ID:
          this.SubBRokerResult.toString() != ""
            ? this.SubBRokerResult.toString()
            : null,
        EMP_ID: this.EmployeeResult.toString(),
        FAMILY_ID: null,
        CLIENT_ID: null,
      };
      const flag =
        this.SubBRokerResult.toString() != ""
          ? "SB_WISE_FAMILY"
          : "EMP_WISE_FAMILY";
      const json = JSON.stringify(request);
      this.reportservice
        .BindEmployeeFilters(this.G_LoginId, this.UserType, flag, json)
        .subscribe((response) => {
          let data = JSON.parse(this.EncrdecrService.getDecr(response));
          this.FamilyList = data.ArrayOfResponse;
          this.Loader.hide();
        });
      this.FamilySetting = {
        singleSelection: false,
        idField: "VALUEFIELD",
        textField: "TEXTFIELD",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        itemsShowLimit: 1,
        allowSearchFilter: true,
      };
    }
  }
  onFamilySelect(e: any) {
    debugger;
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.FamilyResult.indexOf(value);
      if (i == -1) {
        this.FamilyResult.push(value);
      } else {
        this.FamilyResult.splice(i, 1);
      }
    }
  }
  onItemSelectDeselectAllFamily(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.FamilyResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.FamilyResult = [];
        break;
    }
  }
  BindClient() {
    $("body").trigger("click");
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID:
        this.SubBRokerResult.toString() != ""
          ? this.SubBRokerResult.toString()
          : null,
      EMP_ID: this.EmployeeResult.toString(),
      FAMILY_ID: this.FamilyResult.toString(),
      CLIENT_ID: null,
    };
    const json = JSON.stringify(request);

    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(
        this.G_LoginId,
        this.UserType,
        "FAMILY_WISE_CLIENT",
        json
      )
      .subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));
        if (data.ArrayOfResponse != null && data.ArrayOfResponse != undefined) {
          this.ClientList = data.ArrayOfResponse;
        }
        this.Loader.hide();
      });
    this.ClientSetting = {
      singleSelection: true,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onSelectSubBroker(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.SubBRokerResult.indexOf(value);
      if (i == -1) {
        this.SubBRokerResult.push(value);
      } else {
        this.SubBRokerResult.splice(i, 1);
      }
    }
  }
  onItemSelectDeselectAllSubBroker(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.SubBRokerResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.SubBRokerResult = [];
        break;
    }
  }
  onSelectClientL(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.ClientResult.indexOf(value);
      if (i == -1) {
        this.ClientResult.push(value);
      } else {
        this.ClientResult.splice(i, 1);
      }
    }
  }
  onItemSelectDeselectAllClient(items: any, para: number) {
    //
    this.ClientResult = [];
    switch (para) {
      case 0:
        items.map((item) => {
          this.ClientResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.ClientResult = [];
        break;
    }
  }
  onSelectEmpClient(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.EmpClientResult.indexOf(value);
      if (i == -1) {
        this.EmpClientResult.push(value);
      } else {
        this.EmpClientResult.splice(i, 1);
      }
    }
  }
  onItemSelectDeselectAllEmpClient(items: any, para: number) {
    //
    this.EmpClientResult = [];
    switch (para) {
      case 0:
        items.map((item) => {
          this.EmpClientResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.EmpClientResult = [];
        break;
    }
  }
  BindClientToForm() {
    $("body").trigger("click");
    if (this.ClientResult != null && this.ClientResult != undefined) {
      let str = this.ClientResult.toString();
    } else {
    }
    this.ClientResult = [];
  }
  BindEmpClientToForm() {
    $("body").trigger("click");
    if (this.EmpClientResult != null && this.EmpClientResult != undefined) {
      let str = this.ClientResult.toString();
    } else {
    }
    this.EmpClientResult = [];
  }

  BindSBClient() {
    $("body").trigger("click");
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID:
        this.SubBRokerResult.toString() != ""
          ? this.SubBRokerResult.toString()
          : null,
      EMP_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null,
    };
    const json = JSON.stringify(request);
    this.reportservice
      .BindEmployeeFilters(
        this.G_LoginId,
        this.UserType,
        "SB_WISE_CLIENT",
        json
      )
      .subscribe((response) => {
        let data = JSON.parse(this.EncrdecrService.getDecr(response));
        this.ClientList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.ClientSetting = {
      singleSelection: true,
      idField: "VALUEFIELD",
      textField: "TEXTFIELD",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onCheck() {
    //this.Hierarchyform.controls['allFamily'].setValue('');
    $(".CustomSelect0").val("").trigger("change");
    this.RdbReportTypeEmp = !this.RdbReportTypeEmp;
    this.isEmpSub = ""; // modal button disabled
    this.ClearFilters();
  }
  ClearFilters() {
    this.SelectedZone = [];
    this.SelectedRegion = [];
    this.SelectedBranch = [];
    this.SelectedEmployee = [];
    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.EmpSelectedClientList = [];
    $("#SPanNo").val("");
    this.isEmpSub = ""; // modal button disabled
  }
  getClientByPAN() {
    //////
    const Pan = $("#SPanNo").val();
    if (Pan.length == 10) {
      //////
      this.InvalidPan = false;
      this.reportservice
        .getCllientByPan(
          this.G_LoginId,
          this.UserType,
          "CLIENTDETAILS_BYPAN",
          this.EncrdecrService.setEncr(Pan)
        )
        .subscribe((data_res) => {
          let data = JSON.parse(this.EncrdecrService.getDecr(data_res));

          if (data.ArrayOfResponse.length != 0) {
          } else {
            this.CallAlertModal("Client does not exist");
          }
        });
    } else {
      this.InvalidPan = true;
    }
  }
  onChnageClient(e) {
    debugger;
    this.ClientBasicInfoId_Emp = e.target.value;
    if (e && e.target && e.target.value) {
      this.G_ClientBasicInfoId = e.target.value;
    }
  }

  ClientFilterData(e) {
    debugger;
    sessionStorage.setItem(
      "QQX4$E6Qnd",
      this.EncrdecrService.setEncr(JSON.stringify(e))
    ); //session of user details object
    this.ClientPan = "";
    if (e.flag == "employee") {
      let EmpId = e.EmployeId;
      this.G_LoginId = e.EmployeId;
      this.EmpID = e.EmployeId;
      // this.UserType = 1;
      this.flag = "Subbroker";
    } else if (e.flag == "SubBroker") {
      let SBId = e.SubBrokerId;
      this.G_LoginId = e.SubBrokerId;
      this.SubbrokerID = e.SubBrokerId;
      // this.UserType = 2;
      this.flag = "Subbroker";
    } else {
      if (
        e.ClientBasicInfoId != "" &&
        !isNullOrUndefined(e.ClientBasicInfoId)
      ) {
        this.ClientBasicInfoId_Emp = e.ClientBasicInfoId;
        this.G_ClientBasicInfoId = e.ClientBasicInfoId;
        this.G_LoginId = e.ClientID.toString();
        // this.UserType = 1;
        this.flag = "Client";
      }
      //get client pan select client
      if (e && e.clientname && !isNullOrUndefined(e.clientname)) {
        if (e.clientname.split("-")[0].trim()) {
          this.ClientName = e.clientname.split("-")[0].trim();
        }
        if (e.clientname.split("-")[1].trim()) {
          this.ClientPan = e.clientname.split("-")[1].trim();
        }
      }
    }
  }

  ClientFilterData_MfCentral(e) {
    debugger;
    if (e == "") {
      this.ClientPan = "";
    }
  }

  OnCheckClientHoldingDetails() {
    $("#EmpFilterModalMFCentral").modal("hide");
    this.Loader.show();

    const json = {
      TransType: "CHECKDetails",
      pan: this.ClientPan,
      clientId: this.G_ClientBasicInfoId,
      mobile: this.MobileNo,
    };

    let data = JSON.stringify(json);
    this.DashboardNewService.GetTransSummaryHoldingDetails(data).subscribe(
      (res: any) => {
        debugger;
        if (res.Code == 200 && res.Message == "Success") {
          this.Loader.hide();
          this.GetHoldingDetails();
          this.IsUpdateHolding = false;
        } else {
          this.Loader.hide();
          $("#TrackPopUp").modal({
            backdrop: "static",
            keyboard: false,
          });
        }
      },
      (err: any) => {
        this.Loader.hide();
        console.log(err);
      }
    );
  }

  //-----Redirect Lumpsum,Redeem,Factsheet coding started-----
  OpenMenu(
    DifferntiateScheme : any,
    BseSchemeCode: any,
    BSCAMCCode: any,
    FolioNumber: any,
    AmcCodeLogo: any,
    FCTSchemeCode: any,
    SchemeType: any,
    ClassCode: any,
    SchemeName: any,
    Flag: any
  ) {
    debugger;
    this.selectedBSESchemeCode = "";
    this.selectedBSEAMCCode = "";
    this.selectedFCTSchemeCode = "";
    this.selectedFolio = "";
    this.AMCCodeLogo = "";
    this.SchemeType = "";
    this.CategoryCode = "";
    this.DifferentiateScheme = "";
    this.selectedBSESchemeCode = BseSchemeCode;
    this.selectedFCTSchemeCode = FCTSchemeCode;
    this.selectedBSEAMCCode = BSCAMCCode;
    this.selectedFolio = FolioNumber;
    this.AMCCodeLogo = AmcCodeLogo;
    this.SchemeType = SchemeType;
    this.CategoryCode = ClassCode;
    this.SchemeName = SchemeName;
    this.DifferentiateScheme = DifferntiateScheme;

    $("#Menu_Popup").modal({
      backdrop: "static",
      keyboard: false,
    });
  }

  RedirectPage(value: any) {
    debugger;

    setTimeout(() => {
      this.Loader.show();
      $("#Menu_Popup").modal("hide");
      sessionStorage.setItem(
        "jsdjfysbfsdbfsdfsdf",
        this.EncrdecrService.setEncr("Client-DashBoard")
      );
      if (
        this.selectedBSEAMCCode &&
        this.selectedFolio &&
        this.AMCCodeLogo &&
        this.selectedBSESchemeCode &&
        this.selectedFCTSchemeCode &&
        this.G_ClientBasicInfoId
      ) {
        let ClientId = this.G_ClientBasicInfoId;
        switch (value) {
          case "investMore":
            sessionStorage.setItem(
              "Ssdfho238982",
              this.EncrdecrService.setEncr("False")
            );
            // if (this.UserType == '1') {
            //   sessionStorage.setItem('EmphdekEkfkCadDsjkd', this.EncrdecrService.setEncr('True'));
            //   sessionStorage.setItem('EakjdfCAJDS07MF', this.EncrdecrService.setEncr(this.selectedBSEAMCCode));
            //   sessionStorage.setItem('EjfkfCaksAS007MF', this.EncrdecrService.setEncr(this.selectedBSESchemeCode));
            // }
            // else {
            //   sessionStorage.setItem('c1er1RAHrEZBEUH', this.EncrdecrService.setEncr(this.selectedBSEAMCCode));
            //   sessionStorage.setItem('Shv3IZ7dNAGND6w', this.EncrdecrService.setEncr(this.selectedBSESchemeCode));
            // }
            sessionStorage.setItem(
              "C07LI56EwerNeT",
              this.EncrdecrService.setEncr(ClientId)
            );
            sessionStorage.setItem(
              "7N0vMeFeQg",
              this.EncrdecrService.setEncr(this.selectedFolio)
            );

            sessionStorage.setItem(
              "c1er1RAHrEZBEUH",
              this.EncrdecrService.setEncr(this.selectedBSEAMCCode)
            );
            sessionStorage.setItem(
              "Shv3IZ7dNAGND6w",
              this.EncrdecrService.setEncr(this.selectedBSESchemeCode)
            );
            this.RedirectPageName = "";
            this.RedirectPageName = "investMore";
            // this.GetUCCCode(ClientId);
            this.Loader.hide();
            this.router.navigate(["/transaction-new/lumpsum"]);
            break;

          case "withdraw":
            sessionStorage.setItem(
              "Ssdfho238982",
              this.EncrdecrService.setEncr("False")
            );
            sessionStorage.setItem(
              "C07LI56EwerNeT",
              this.EncrdecrService.setEncr(ClientId)
            );
            // sessionStorage.setItem('hdekEkfkCadDsjkd', this.EncrdecrService.setEncr('True'));
            // sessionStorage.setItem('7N0vMeFeQg', this.EncrdecrService.setEncr(this.selectedFolio));
            // sessionStorage.setItem('CLeiEcASkdeij', this.EncrdecrService.setEncr(this.selectedFCTSchemeCode));
            // sessionStorage.setItem('ROUdocYCPa', this.EncrdecrService.setEncr(this.selectedFCTSchemeCode));
            // sessionStorage.setItem('ea60m0rIgd', this.EncrdecrService.setEncr(this.SchemeName));
debugger
            let SelectedScheme = {
              Folio: this.selectedFolio,
              SchemeCode: this.selectedFCTSchemeCode,
              DifferentiateScheme : this.DifferentiateScheme
            };

            sessionStorage.setItem(
              "YCb0heBk3kWGpXLolI=",
              this.EncrdecrService.setEncr(JSON.stringify(SelectedScheme))
            );
            this.RedirectPageName = "";
            this.RedirectPageName = "withdraw";
            // this.GetUCCCode(ClientId);
            this.Loader.hide();
            this.router.navigate(["/transaction-new/redeem"]);
            break;

          case "viewSchemeDetails":
            sessionStorage.setItem(
              "c1er1RAHrEZBEUH",
              this.EncrdecrService.setEncr(this.selectedBSEAMCCode)
            );
            sessionStorage.setItem(
              "spctOLvdLYaz0Vy",
              this.EncrdecrService.setEncr(this.selectedFCTSchemeCode)
            );
            sessionStorage.setItem(
              "LxRzbMcYUYnVVJx",
              this.EncrdecrService.setEncr(this.AMCCodeLogo)
            );
            sessionStorage.setItem(
              "Shv3IZ7dNAGND6w",
              this.EncrdecrService.setEncr(this.selectedBSESchemeCode)
            );
            sessionStorage.setItem("SSCChhMMeYpre", this.SchemeType);
            $("#Menu_Popup").modal("hide");
            // //Added by Jay for Below sessoin
            // sessionStorage.setItem('Po8djmnidf7', 'DirectSchemeRedirectoEcas');
            // sessionStorage.setItem('FROmEassCAS', 'FromECAS');

            sessionStorage.setItem(
              "Shv3IZ7dNAGND6w",
              this.EncrdecrService.setEncr(this.selectedBSESchemeCode)
            );

            // sessionStorage.setItem(
            //   "CatOTtegory$C0de",
            //   this.EncrdecrService.setEncr(this.CategoryCode)
            // );

            this.Loader.hide();
            // this.router.navigate(["/factsheet"], { relativeTo: this.route });
            this.router.navigate(["/factsheet-new"], {
              relativeTo: this.route,
            });
            break;
        }
      } else {
        this.Loader.hide();
      }
    }, 100);
  }
}
